module.exports = __webpack_public_path__ + "img/14.1d2c7a8d.png";